import AzureImg from '../../../assets/images/itm-azure-1.png';
import CybersecurityImg from '../../../assets/images/itmonkeys-cyber-landing.png';
import { Service } from './types'
import CloudServiceImg from '../../../assets/images/itmonkeys-infra-cloud.png';
import SynologyImg from '../../../assets/images/itmonkeys-synology.png';
import TrainingImg from '../../../assets/images/itmonkeys-cyber-landing.png';
import OpenAIImg from '../../../assets/images/itmonkeys-azure-openai-img.png';
import IAImg from '../../../assets/images/IT Monkeys robot.png'
import AcademyImg from '../../../assets/images/itmonkeys-gradient.png'
import CloudImg from '../../../assets/images/cloud-blue.png'
export const services: Service[] = [
  {
    id: 1,
    icon: AzureImg,
    alt: 'Cloud infrastructure IT Monkeys',
    title: "Conception d'infra cloud",
    subtitle: 'Architectures cloud sur mesure.',
    description: "Disposez dès maintenant d'une architecture cloud moderne et performante.",
    link: '/cloudmigration',
  },
  {
    id: 2,
    icon: AcademyImg,
    alt: 'Cloud Admin IT Monkeys',
    title: 'Administration cloud',
    subtitle: 'Externalisez la gestion de vos infrastructures.',
    description: 'Confiez à des experts la gestion de vos systèmes cloud en l\'externalisant.',
    link: '/cloudadmin',
  },
  {
    id: 3,
    icon: CloudImg,
    alt: 'Migration Cloud IT Monkeys',
    title: 'Migration vers le cloud',
    subtitle: 'Modernisez votre SI.',
    description: 'Nous orchestrons méthodiquement la migration de votre infrastructure vers le cloud.',
    link: '/secureteleworking',
  },
  {
    id: 4,
    icon: SynologyImg,
    alt: 'Cloud Privé IT Monkeys',
    title: 'Cloud privé sur NAS',
    subtitle: 'Pour une sécurité et contrôle total.',
    description: 'Centralisez et accédez à vos données en toute sécurité, où que vous soyez.',
    link: '/privatecloud',
  },
];
